var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lDfault',{attrs:{"title":"教材退货"}},[_vm._v(" 教材退货 ")])}
var staticRenderFns = []

export { render, staticRenderFns }